// extracted by mini-css-extract-plugin
module.exports = {"component":"index_component__2catU","card":"index_card__3Uthu","logo":"index_logo__29XDu","desc":"index_desc__1UQLX"};